import { render } from "./LocuriMunca.vue?vue&type=template&id=2dae230e"
import script from "./LocuriMunca.vue?vue&type=script&lang=js"
export * from "./LocuriMunca.vue?vue&type=script&lang=js"

import "./LocuriMunca.vue?vue&type=style&index=0&id=2dae230e&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__